<template>
  <div class="bg-radient-light-repeat">
    <div
      class="
        pdf-padding-top pdf-padding-left pdf-padding-right pdf-padding-bottom
        text-left
      "
    >
      <h2 class="hr hr-left content-bottom-margin">TOKENOMICS</h2>
      <p class="text-m">
        <span class="bold">THE ATH GAMES TOKEN</span> is a utility token with
        automated yield and liquidity generation. It has a maximum supply of
        <span class="bold">100 billion,</span> with the majority being locked.
        There is a <span class="bold">6%</span> transaction fee that takes place
        on every buy and sell.
        <span class="break" style="margin-left: 2vw"
          >This token will later be made part of a bigger ecosystem, with
          governance and play-to-earn</span
        >
        utilities in mind. Our space in the
        <span class="bold">metaverse</span> will contain true AAA game titles,
        all of them harnessing the power of blockchain technology. We believe
        decentralization can be done right and we will pursue that ideology.
        <span class="break" style="margin-left: 2vw"
          >The perfect <span class="bold">DAO</span> is yet to be created but
          one day we will be a community-driven liquid</span
        >
        democracy. This will enable token holders to influence the development
        of our games as well as our ecosystem as a whole.
      </p>
      <p class="text-m pdf-margin-bottom">
        <span class="bold">TLDR:</span> This token will help fund the
        development of both the business and our games.
        <span class="break"
          >It will also allow holders to partake in community events such as
          competitions and voting.</span
        >
      </p>

      <h3 class="hr hr-left" style="margin-bottom: 2vw">TOKEN ALLOCATION</h3>
      <div class="center-horizontal content-bottom-margin">
        <img src="../assets/img/token_alloc.png" alt="" style="width: 90%" />
      </div>
      <div class="center-horizontal content-bottom-margin text-m">
        <table>
          <tr>
            <th class="left">ALLOCATED GROUP</th>
            <th class="center">%</th>
            <th class="right">NO OF TOKENS</th>
          </tr>
          <tr>
            <td class="left">TOTAL SUPPLY</td>
            <td class="center">100</td>
            <td class="right">100,000,000,000</td>
          </tr>
          <tr>
            <td class="left">STAKING</td>
            <td class="center">20</td>
            <td class="right">20,000,000,000</td>
          </tr>
          <tr>
            <td class="left">PLAY TO EARN</td>
            <td class="center">18</td>
            <td class="right">18,000,000,000</td>
          </tr>
          <tr>
            <td class="left">CORE TEAM</td>
            <td class="center">16</td>
            <td class="right">16,000,000,000</td>
          </tr>
          <tr>
            <td class="left">ECOSYSTEM FUND</td>
            <td class="center">12</td>
            <td class="right">12,000,000,000</td>
          </tr>
          <tr>
            <td class="left">PUBLIC SALE</td>
            <td class="center">12</td>
            <td class="right">12,000,000,000</td>
          </tr>
          <tr>
            <td class="left">RESERVE</td>
            <td class="center">10</td>
            <td class="right">10,000,000,000</td>
          </tr>
          <tr>
            <td class="left">ADVISORS</td>
            <td class="center">8</td>
            <td class="right">8,000,000,000</td>
          </tr>
          <tr>
            <td class="left">PRIVATE SALE</td>
            <td class="center">4</td>
            <td class="right">4,000,000,000</td>
          </tr>
        </table>
      </div>
      <h3 class="hr hr-left content-bottom-margin">TOKEN RELEASE SCHEDULE</h3>
      <div class="center-horizontal content-bottom-margin">
        <img src="../assets/img/release.png" alt="" />
      </div>

      <h3 class="hr hr-left content-bottom-margin">TRANSACTION FEE 6%</h3>

      <div class="row no-space center-vertical">
        <div class="col-md-4 center-horizontal">
          <img
            src="../assets/img/transaction_fee.png"
            alt=""
            style="width: 20vw"
          />
        </div>
        <div class="col-md-8 center-horizontal mobile-top-margin">
          <div>
            <p class="text-m">
              <span class="bold">THE 6% TRANSACTION FEE</span> is divided into
              two portions:
              <span class="break">
                <span class="bold">60% </span> of this fee (<span class="bold"
                  >3.6%</span
                >
                of the total transaction value)</span
              >
              will be used in an automated
              <span class="bold">BuyBackAndBurn</span> function.
              <span class="break"
                >This function both <span class="bold">strengthens</span> the
                Liquidity Pool and</span
              >
              permanently reduces the total supply of the ATHD Token,
              <span class="break">
                <span class="bold">increasing</span> demand.</span
              >
              <span class="bold">40%</span> of the fee (<span class="bold"
                >2.4%</span
              >
              of the total transaction value)
              <span class="break"
                >will go to the
                <span class="bold">Developer Wallet,</span> which is used for
                running</span
              >
              our operations.
            </p>
            <p class="text-m">
              The fee will later be moved from our token to our
              <span class="break">marketplace. More information TBA.</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <SocialIcons />
  </div>
</template>

<script>
import SocialIcons from "../components/SocialIcons.vue";
export default { components: { SocialIcons } };
</script>

<style scoped>
.text-margin {
  margin-left: 1em;
}
.text-m {
  font-size: clamp(0.6rem, 1.4vw, 4rem);
}

th {
  padding-left: 4.5vw;
  padding-right: 4.5vw;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
td {
  padding-left: 4.5vw;
  padding-right: 4.5vw;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
table {
  border-spacing: 0 !important;
}
.left {
  text-align: left;
}
.center {
  text-align: center;
}
.right {
  text-align: right;
}
@media (max-width: 992px) {
  .mobile-top-margin {
    margin-top: 2vw;
  }
  .col-md-8 .break {
    display: initial;
  }
}
</style>
